export const search =
  "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADQAAAAWCAYAAACPHL/WAAAAAXNSR0IArs4c6QAAAEdJREFUWAnt11EJADAIRdGXaSu0COaz3IwhXK7gt3gQ1Jzqd6s/JYNrKIYCCiiggAKLArjFimtocTgsrYACCiigAO8Fp10KA4pd3H9jHdZuAAAADmVYSWZNTQAqAAAACAAAAAAAAADSU5MAAAAASUVORK5CYII=";
